import type { FC } from "react";
import { Icon } from "@onshopfront/components";
import type { QueuedItem } from "#/Data/_Bases/BaseUploadRepository.ts";
import { SynchroniseError } from "#/Layout/Header/SiteStatus/SynchroniseError.tsx";
import type { UPLOAD_TYPES } from "#/Workers/Upload/UploadEvents.ts";

export type SyncErrorsType = Partial<Record<UPLOAD_TYPES, Array<QueuedItem<UPLOAD_TYPES>>>>;

interface Props {
    errors: SyncErrorsType;
    embeddedDisabled: boolean;
    onDismiss: (ids: Array<number>) => void;
}

export const SynchroniseErrors: FC<Props> = ({
    errors: errorMap,
    embeddedDisabled,
    onDismiss,
}) => {
    return (
        <div className="synchronise-errors">
            {embeddedDisabled && (
                <div className="synchronise-error warning">
                    <div className="error-icon">
                        <Icon
                            icon={[ "fal", "exclamation" ]}
                            className="mr-2"
                        />
                    </div>
                    <div className="error-text">
                        Integrations are disabled
                    </div>
                </div>
            )}
            {(Object.keys(errorMap) as Array<UPLOAD_TYPES>).map(type => {
                const errors = errorMap[type];

                if(typeof errors === "undefined") {
                    return null;
                }

                return (
                    <SynchroniseError
                        key={type}
                        type={type}
                        count={errors.length}
                        onDismiss={() => {
                            const ids: Array<number> = [];

                            for(const { id } of errors) {
                                if(typeof id !== "number") {
                                    continue;
                                }

                                ids.push(id);
                            }

                            onDismiss(ids);
                        }}
                    />
                );
            })}
        </div>
    );
};
